import AppConsts from './appconst'
import Util from './util'
import * as signalR from "@aspnet/signalr";
class SignalRAspNetCoreHelper{
    initSignalR(){
        var encryptedAuthToken = Util.abp.utils.getCookieValue(AppConsts.authorization.encrptedAuthTokenName);

        Util.abp.signalr = {
            autoConnect: true,
            connect: undefined,
            hubs: undefined,
            qs: AppConsts.authorization.encrptedAuthTokenName + "=" + encodeURIComponent(encryptedAuthToken),
            remoteServiceBaseUrl: AppConsts.remoteServiceBaseUrl,
            url: '/signalr'
        };

        Util.loadScript(AppConsts.appBaseUrl + '/dist/abp.signalr-client.js');

        setTimeout(() => {
            const conn = (abp as any).signalr.hubs.common;
            console.log('conn', conn);
            this.RegistListenning(conn);
        }, 1500);
    }

    private RegistListenning(connection: signalR.HubConnection): void {
        connection.on("messageReceived", (data) => {
            console.log(data);
            abp.event.trigger('app.messageReceived', data);
        });

        connection.on("kickOut", (data) => {
            abp.event.trigger('app.kickOut', data);
        })
        connection.on("sendDownTradeSchedule", data => {
            abp.event.trigger('app.sendDownTradeSchedule', data);
        })
        connection.on("logisticsService", data => {
            abp.event.trigger('app.logisticsService', data);
        })
        connection.on("payService", data => {
            abp.event.trigger('app.payService', data);
        })
        connection.on("sendSignalrId", data => {
            console.log("sendSignalrId")
            abp.event.trigger('app.SendSignalrId', data);
        })
        //distributionReceived
        connection.on("distributionReceived", data => {
            abp.event.trigger('app.distributionReceived', data);
        })
        connection.on("SendTrade", data => {
            abp.event.trigger('app.SendTrade', data);
        })

        connection.on("StockIn", data => {
            console.log(data);
            abp.event.trigger('app.StockIn', data);
        })

        connection.on("StockOut", data => {
            abp.event.trigger('app.StockOut', data);
        })

        connection.on("AutoStockOut", data => {
            abp.event.trigger('app.AutoStockOut', data);
        })
        connection.on("TransferStockOut", data => {
            abp.event.trigger('app.TransferStockOut', data);
        })
        connection.on("DeliveryStockOut", data => {
            abp.event.trigger('app.DeliveryStockOut', data);
        })
        //FxBalanceRecharge
        connection.on("FxBalanceRecharge", data => {
            abp.event.trigger('app.FxBalanceRecharge', data);
        })
        //ImportOrder
        connection.on("ImportOrder", data => {
            abp.event.trigger('app.ImportOrder', data);
        })
        connection.on("DeleteOrder", data => {
            abp.event.trigger('app.DeleteOrder', data);
        })
        //AuditRechargeRecord
        connection.on("AuditRechargeRecord", data => {
            abp.event.trigger('app.AuditRechargeRecord', data);
        })
        //AuditApplyUpgrade
        connection.on("AuditApplyUpgrade", data => {
            abp.event.trigger('app.AuditApplyUpgrade', data);
        })
        connection.on("AuditAssist", data => {
            abp.event.trigger('app.AuditAssist', data);
        })
        //PrivateCofferWithdrawApproved
        connection.on("PrivateCofferWithdrawApproved", data => {
            abp.event.trigger('app.PrivateCofferWithdrawApproved', data);
        })
        connection.on("PrivateCofferWithdrawNotApproved", data => {
            abp.event.trigger('app.PrivateCofferWithdrawNotApproved', data);
        })
        connection.on("CloundWithDrawPass", data => {
            abp.event.trigger('app.CloundWithDrawPass', data);
        })
        connection.on("CloundWithDrawFail", data => {
            abp.event.trigger('app.CloundWithDrawFail', data);
        })
        //ReturnEarnestmoneyApproved
        connection.on("ReturnEarnestmoneyApproved", data => {
            abp.event.trigger('app.ReturnEarnestmoneyApproved', data);
        })
        //ReturnEarnestWxMoney
        connection.on("ReturnEarnestWxMoney", data => {
            abp.event.trigger('app.ReturnEarnestWxMoney', data);
        })
        //SplitOrderByNum
        connection.on("SplitOrderByNum", data => {
            abp.event.trigger('app.SplitOrderByNum', data);
        })
        connection.on("ZQWinLottery", data => {
            abp.event.trigger('app.ZQWinLottery', data);
        })
        connection.on("SetLogisticNo", data => {
            abp.event.trigger('app.SetLogisticNo', data);
        })
        connection.on("StockIn", data => {
            abp.event.trigger('app.StockIn', data);
        })
        connection.on("StockOut", data => {
            abp.event.trigger('app.StockOut', data);
        })
        connection.on("pkactive", data => {
            abp.event.trigger('app.pkactive', data);
        })
    }
}
export default new SignalRAspNetCoreHelper();